type GetFilterCountOptions = {
  searchParams: URLSearchParams;
  allowedParams: string[];
};

export const getFilterCount = ({
  searchParams,
  allowedParams,
}: GetFilterCountOptions) => {
  let count = 0;

  for (const param of allowedParams) {
    if (searchParams.has(param)) {
      count++;
    }
  }

  return count;
};
